export default __webpack_public_path__ + "static/media/play-300x116.28bf1615.png";